"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const createJourneyComponent_1 = require("../../lib/createJourneyComponent");
const ProgressBarIndicator = createJourneyComponent_1.createJourneyComponent('j-progress-bar-indicator', 'div');
const ProgressBar = (props) => {
    const { percentage, children } = props;
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)),
        react_1.default.createElement(ProgressBarIndicator, { style: { width: `${percentage !== null && percentage !== void 0 ? percentage : 0}%` } }),
        children));
};
exports.default = withJourney_1.default('j-progress-bar', ProgressBar);
